










import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import formatter from '@/mixins/formatter';

import LineCount from '@/components/Atoms/Text/LargeLineCount.vue';

@Component({
  components: {
    LineCount,
  },
})
export default class TotalLineCount extends mixins(formatter) {
  @Prop() private count!: number;
  @Prop({ default: '' }) id?: string;
}
